import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PilotFooterContainer = styled.div<React.CSSProperties>`
  bottom: 0;
  height: ${440 * Screen.widthRatio}px;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

export default PilotFooterContainer;
